<button class="bx--modal-close position-static"
  type="button"
  data-modal-close
  aria-label="close modal">
  <ibm-icon-close size="20"></ibm-icon-close>
</button>